import { render, staticRenderFns } from "./DataAndPayments.vue?vue&type=template&id=54d3d978&scoped=true&"
import script from "./DataAndPayments.vue?vue&type=script&lang=js&"
export * from "./DataAndPayments.vue?vue&type=script&lang=js&"
import style0 from "./DataAndPayments.vue?vue&type=style&index=0&id=54d3d978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d3d978",
  null
  
)

export default component.exports